import styled from 'styled-components';

export const PageHeaderWrapper = styled.header`
  position: relative;
  padding: 60px 20px;
  text-align: center;
  color: #ffffff;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #000000;
`;

export const PageHeaderOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
`;

export const PageHeaderInner = styled.div`
  position: relative;
  max-width: 900px;
  margin: 0 auto;
`;

export const PageHeaderTitle = styled.h1`
  margin: 0 0 12px;
  font-size: 2rem;
`;

export const PageHeaderSubtitle = styled.p`
  margin: 0;
  font-size: 1rem;
`;
